export default __webpack_public_path__ + "static/GAP_insurance_3-9174d291831daa3c844615458f63216b.webp";